import { apiRequest } from './httpRequest';
import type { BiopolymerDrawingDocument } from '@peruselab/structure-editor/chemistry/biopolymerResidue';

export interface BiopolymerResponse {
  readonly id: string;
  readonly documentRevision: number;
  readonly title: string | null;
  readonly schemaVersion: string;
  readonly document: BiopolymerDrawingDocument;
  readonly ownerType: string;
  readonly ownerId: string;
  readonly createdAt: string;
  readonly updatedAt: string;
}

// #150: mirrors createReaction/createIllustration -- POST /api/biopolymers has existed
// server-side since #149.
export async function createBiopolymer(
  document: BiopolymerDrawingDocument,
  title?: string
): Promise<BiopolymerResponse> {
  const normalizedTitle = title?.trim();
  const query = normalizedTitle ? `?${new URLSearchParams({ title: normalizedTitle })}` : '';
  return apiRequest<BiopolymerResponse>(`/biopolymers${query}`, 'biopolymer', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(document)
  });
}
